enum PermissionAccessStatus {
  Granted = 'granted',
  Denied = 'denied',
}

export default PermissionAccessStatus;
